import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import "./form-item-mymo-gb-callback.component.scss";
var FormItemMymoGbCallback = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMymoGbCallback, _super);
    function FormItemMymoGbCallback(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemMymoGbCallback.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.displayModal = this.element.querySelector(".modal__dialog");
        this.displayTitle = this.element.querySelector(".apply-now__title--module-title");
        this.buttonSubmit = Array.from(this.element.querySelectorAll(".js-mymo-plus-account-call-me-backSubmit_button"));
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayMessageSuccess = this.element.querySelector(".form-container__success");
            this.displayMessageFail = this.element.querySelector(".form-container__error");
            this.displayFields = this.form.querySelector(".form-container__fields");
        }
    };
    FormItemMymoGbCallback.prototype.bindEvents = function () {
        var _this = this;
        this.buttonSubmit.map(function (item) {
            return item.addEventListener("click", function (event) {
                var formFields = _this.form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.showDisplayView("loader");
                    // Check if gRecaptcha is enabled for this form
                    if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                        var gToken_1 = '';
                        try {
                            // Attempt to get recaptcha token
                            grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var err_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                        case 1:
                                            gToken_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_1 = _a.sent();
                                            // Log error
                                            console.log("Unable to retrieve gRecaptcha Token");
                                            console.log(err_1);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            // Set recaptcha token
                                            this.gRecaptchaToken = gToken_1;
                                            this.submitForm();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        catch (err) {
                            // Log error
                            console.log("Unable to retrieve gRecaptcha Token");
                            console.log(err);
                            _this.submitForm();
                        }
                    }
                    else {
                        _this.submitForm();
                    }
                }
            });
        });
    };
    FormItemMymoGbCallback.prototype.submitForm = function () {
        var _this = this;
        var firstName = this.form.querySelector("input[name=firstName]");
        var surName = this.form.querySelector("input[name=lastName]");
        var idNumber = this.form.querySelector("input[name=idNumber]");
        var cellNumber = this.form.querySelector("input[name=phoneNumber]");
        var altCellNumber = this.form.querySelector("input[name=alternativePhoneNumber]");
        var monthlyExpenses = this.form.querySelector("input[name=monthlyExpenses]");
        var grossIncome = this.form.querySelector("input[name=grossIncome]");
        var consentsOne = this.form.querySelector("input[name=consentsOne]");
        var consentsTwo = this.form.querySelector("input[name=consentsTwo]");
        var consentsThree = this.form.querySelector("input[name=consentsThree]");
        var consentsFour = this.form.querySelector("input[name=consentsFour]");
        var consentsFive = this.form.querySelector("input[name=consentsFive]");
        var consentsSix = this.form.querySelector("input[name=consentsSix]");
        var popiConsent = this.form.querySelector("input[name=terms-and-conditions]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _dateTime = "anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var firstNameValue = firstName ? firstName.value : "";
        var lastNameValue = surName ? surName.value : "";
        var fullName = firstNameValue + " " + lastNameValue;
        var requestData = {
            // fullName: fullName,
            firstName: firstName.value,
            surName: surName.value,
            contactNumber: cellNumber.value,
            altContactNumber: altCellNumber.value,
            saId: idNumber ? idNumber.value : "",
            monthlyExpenses: monthlyExpenses.value,
            grossIncome: grossIncome.value,
            consentsOne: consentsOne.checked ? "Yes" : "No",
            consentsTwo: consentsTwo.checked ? "Yes" : "No",
            consentsThree: consentsThree.checked ? "Yes" : "No",
            consentsFour: consentsFour.checked ? "Yes" : "No",
            consentsFive: consentsFive.checked ? "Yes" : "No",
            consentsSix: consentsSix.checked ? "Yes" : "No",
            popiConsent: popiConsent.checked ? "Yes" : "No",
            description: "Achieva",
            timeToCall: _dateTime,
            sbsaCustomer: "NO",
            emailAddress: "",
            source: "",
            status: "",
            declinedReason: "",
            recaptchaToken: this.gRecaptchaToken
        };
        var url = this.baseUrl + "/leadsutils/savemymoplusprop";
        var _config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        };
        this.formsService
            .postForm(url, requestData, _config)
            .then(function (response) {
            if (!response.data || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else if (response.data.captchaResponse != null && response.data.captchaResponse == false) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", "200", true, "", "", cellNumber.value);
                _this.showDisplayView("success");
            }
        })
            .catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemMymoGbCallback.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayMessageFail.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displayMessageSuccess.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displayMessageSuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayMessageFail.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemMymoGbCallback;
}(Base));
export { FormItemMymoGbCallback };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-mymo-gb-callback/form-item-mymo-gb-callback.component.ts
// module id = 957
// module chunks = 0